/** biome-ignore-all lint/style/useNamingConvention: GA4 reserved param names */
import type { AnalyticsEventParamsType, IAnalyticsAdapter } from '@repo/analytics';
import { getDataLayer } from './get-data-layer';

export const gtmDataLayerAdapter: IAnalyticsAdapter = {
  track: (eventName: string, params?: AnalyticsEventParamsType): void => {
    const layer = getDataLayer();
    if (!layer) {
      return;
    }
    layer.push({ event: eventName, ...(params ?? {}) });
  },
  identify: (userId: string): void => {
    const layer = getDataLayer();
    if (!layer) {
      return;
    }
    layer.push({ user_id: userId });
  },
  setUserProperty: (key: string, value: string): void => {
    const layer = getDataLayer();
    if (!layer) {
      return;
    }
    layer.push({ [key]: value });
  },
  reset: (): void => {
    const layer = getDataLayer();
    if (!layer) {
      return;
    }
    layer.push({ event: 'reset' });
  },
  trackScreen: (screenName: string): void => {
    const layer = getDataLayer();
    if (!layer) {
      return;
    }
    layer.push({
      event: 'page_view',
      page_path: screenName,
      page_title: typeof document === 'undefined' ? screenName : document.title,
      page_location: typeof window === 'undefined' ? screenName : window.location.href,
    });
  },
};
